import { ReactNode } from "react";

type ITabPanelProps = {
	children: ReactNode;
	value: number;
	index: number;
	other?: string | undefined;
};

/**
 * TabPanel component for rendering a tab's content.
 *
 * @param {ITabPanelProps} props - Component props.
 * @returns {JSX.Element} - React JSX element representing the tab panel.
 */
const TabPanel = (props: ITabPanelProps) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			hidden={value !== index}
			id={index.toString()}
			aria-labelledby={index.toString()}
			{...other}
		>
			{value === index && children}
		</div>
	);
};

export default TabPanel;
